
export default {
    dark: {
        base0: '#A7B2C7',
        base1: '#D8DEE9',
        base2: '#E5E9F0',
        base3: '#ECEFF4',
        bg0: '#4C566A',
        bg1: '#434C5E',
        bg2: '#3B4252',
        bg3: '#2E3440',
        yellow: '#FFCA15',
        orange: '#FF4B15',
        red: '#FF145C',
        magenta: '#FF1FA3',
        violet: '#A553FF',
        blue: '#00BEFF',
        cyan: '#10FFFD',
        green: '#1DFF7C'
    },
    light: {
        base0: '#A7B2C7',
        base1: '#D8DEE9',
        base2: '#E5E9F0',
        base3: '#ECEFF4',
        bg0: '#4C566A',
        bg1: '#434C5E',
        bg2: '#3B4252',
        bg3: '#2E3440',
        yellow: '#D3A300',
        orange: '#FF4B15',
        red: '#FF145C',
        magenta: '#FF1FA3',
        violet: '#9D43FF',
        blue: '#00BEFF',
        cyan: '#10FFFD',
        green: '#1DFF7C'
    }
};
